<template>
  <form @submit.prevent="submit">
    <fields
      :fields="fields.all()"
      :model="model"
      :errors="errors" />
    <div class="form-group">
      <b-button
        type="submit"
        variant="primary">
        Save
      </b-button>
      <b-button
        type="button"
        variant="light"
        @click="cancel">
        Cancel
      </b-button>
    </div>
  </form>
</template>

<script>
import Layout from '../layouts/Default.vue';
import ResourceFormMixin from '../mixins/ResourceFormMixin';
import Proxy from './Proxy';

export default {
  name: 'TermsForm',

  components: {
    Layout,
  },

  mixins: [ResourceFormMixin],

  created() {
    this.loadForm(Proxy)
      .then(() => {
        if (this.$route.params.taxonomy) {
          this.setFields([
            ...this.fields.list,
            {
              attribute: 'taxonomy',
              component: 'text-field',
              type: 'hidden',
              value: null
            }
          ])

          this.model.taxonomy = this.$route.params.taxonomy;
          this.fields.get('taxonomy').value = this.$route.params.taxonomy;
          this.fields.get('taxonomy').disabled = true;
        }
      });
  },

  methods: {
    submit() {
      this.save(Proxy)
        .then(() => {
          this.$toast.success('Term was saved successfully');
        });
    },
  },

};
</script>
